import { CellValue } from 'react-table';

/**
 * Aggregates columns of NumberRange values into a single NumberRange value.
 */
export const aggregateNumberRange = (
    columnValues: CellValue<NumberRange>[],
): NumberRange =>
    columnValues.reduce(
        (acc: NumberRange, curr: NumberRange) => {
            if (curr.max > acc.max) {
                acc.max = curr.max;
            }

            if (curr.min > acc.min) {
                acc.min = curr.min;
            }

            return acc;
        },
        { max: 0, min: 0 },
    );
